export const matchesQuery = ({
  user,
  title,
}, query) => {
  // https://stackoverflow.com/a/37511463/3720597
  const removeAccents = x => x.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

  const normalize = (x = '') => removeAccents(x).replace(/(\W|_)/g, '').toLowerCase()

  const name = normalize(user.name || user.email)
  title = normalize(title)
  query = normalize(query)

  return name.includes(query) || title.includes(query)
}



// WEBPACK FOOTER //
// ./src/search.js